import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio Newsletter" mdxType="Seo" />
    <h1 {...{
      "id": "pyohio-newsletter"
    }}>{`PyOhio Newsletter`}</h1>
    <p>{`Keep up with the latest news and announcements from PyOhio by `}<a parentName="p" {...{
        "href": "https://landing.mailerlite.com/webforms/landing/b7n4x6",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`subscribing to our newsletter`}</a>{`.
We typically send 1-2 emails per month and will never share your email address with anyone else.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      